import React, { useEffect, useState } from "react";
import { nanoid } from "nanoid";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import queryString from "query-string";
import { useTranslation } from "react-i18next";
import _ from "lodash";

import { arrowHorizontal, filterLines, timeStroke } from "../../svgs";
import { FilterDropdown } from "./styled";

export default function Filter({ open, toggleMenu }) {
  const { t } = useTranslation();

  const timeMock = [
    {
      headline: "დღის",
      value: "day",
    },
    {
      headline: "კვირის",
      value: "week",
    },
    {
      headline: "თვის",
      value: "month",
    },
  ];

  const [timeFilter, setTimeFilter] = useState({
    headline: "ფილტრი",
    value: null,
  });

  const [searchParams, setSearchParams] = useSearchParams();
  let location = useLocation();
  let navigate = useNavigate();
  const parsedSearch = queryString.parse(location.search);

  const handleFilter = (val) => {
    setTimeFilter(val);
    toggleMenu();

    delete parsedSearch.page;
    // const removedQuery = _.omit(parsedSearch, 'page');

    if (!parsedSearch.ordering) {
      // navigate(`${location.search}${location.search ? "&" : "?"}ordering=${val.value}`);
      const addQuery = _.assign(parsedSearch, { ordering: `${val.value}` });
      const stringified = queryString.stringify(addQuery);
      navigate("/?" + stringified);
    } else {
      parsedSearch.ordering = val.value;
      const stringified = queryString.stringify(parsedSearch);
      navigate("?" + stringified);
    }
  };
  const popPagination = () => {
    const param = searchParams.get("page");
    if (param) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
  };

  useEffect(() => {
    const filterQ = parsedSearch.ordering;
    if (filterQ) return setTimeFilter({ headline: t(filterQ), value: filterQ });
    return setTimeFilter({ headline: "ფილტრი", value: null });
  }, [location.search]);

  return (
    <FilterDropdown open={open}>
      <button className="label" onMouseUp={() => toggleMenu()}>
        {filterLines()}
        <span>{timeFilter.headline}</span>
        {arrowHorizontal()}
      </button>

      <div className="options">
        <button onMouseUp={() => handleFilter("ფილტრი")}>ფილტრი</button>
        {timeMock.map((time, i) => {
          return (
            <button
              className={`${
                timeFilter.headline === time.headline ? "active" : ""
              }`}
              key={nanoid()}
              onMouseUp={() => handleFilter(time)}
            >
              {time.headline}
            </button>
          );
        })}
      </div>
    </FilterDropdown>
  );
}
